<template>
  <v-navigation-drawer
    :value="isAmazonSESv2ConfigOpen"
    @input="inputAmazonSESv2Config"
    width="600px"
    right
    fixed
    temporary
    style="z-index: 200; transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
  >
    <BaseToolbar
      :button-save="true"
      :loader-save="saveLoading"
      :button-save-disabled="isSaveDisabled"
      color="#2661FF"
      :dark="true"
      @close="close"
      @save="save"
      title="Amazon SES v2"
      type-title="icon"
      icon="edit"
    />
    <v-row v-if="loading">
      <v-col
        cols="12"
        class="d-flex justify-center align-center"
        style="height: 90vh;"
      >
        <v-progress-circular indeterminate size="62" color="#2661FF" />
      </v-col>
    </v-row>
    <v-row v-else class="pa-4">
      <v-col cols="12" class="mt-2">
        <h2 class="title text_color d-flex justify-center">
          Relaciona una cuenta de AWS con la organización.
        </h2>
      </v-col>
      <v-col cols="12">
        <v-card class="custom_card" flat>
          <v-card-title class="justify-center">
            <p class="body-2 text_color" style="word-break: keep-all;">
              Aquí podrás relacionar una cuenta de AWS previamente configurada
              con la organización
            </p>
          </v-card-title>
          <v-card-text>
            <v-form ref="send-email-account-form">
              <v-row no-gutters>
                <v-col cols="12">
                  <label for="account">Seleccionar cuenta</label>
                  <v-select
                    v-model="selectedSendEmailAccountId"
                    :items="sendEmailAccounts"
                    :rules="[value => !!value || 'El campo es requerido']"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    clearable
                    class="rounded-lg"
                    placeholder="Seleccionar cuenta"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar.vue'

export default {
  name: 'AmazonSESv2',
  components: {
    BaseToolbar
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      isSaveDisabled: false,
      selectedSendEmailAccountId: null
    }
  },
  async created() {
    this.loading = true
    await this.fetchAmazonSESv2Account({
      organizationId: this.organization.id
    })
    await this.fetchAllSendEmailAccounts()
    this.selectedSendEmailAccountId = this.amazonSesV2Configuration.sendEmailAccountId
    this.loading = false
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      sendEmailAccounts: ({ onboarding: { aws } }) => aws.sendEmailAccounts,
      isAmazonSESv2ConfigOpen: ({ accounts: { isAmazonSESv2ConfigOpen } }) =>
        isAmazonSESv2ConfigOpen,
      amazonSesV2Configuration: ({ accounts: { amazonSesV2Configuration } }) =>
        amazonSesV2Configuration
    })
  },
  methods: {
    ...mapActions({
      saveSESv2Account: 'accounts/saveSESv2Account',
      fetchAmazonSESv2Account: 'accounts/fetchAmazonSESv2Account',
      fetchAllSendEmailAccounts: 'onboarding/fetchAllSendEmailAccounts'
    }),
    ...mapMutations({
      toggleAmazonSESv2Config: 'accounts/toggleAmazonSESv2Config'
    }),
    inputAmazonSESv2Config(arg) {
      if (!arg) {
        this.toggleAmazonSESv2Config(false)
      }
    },
    close() {
      this.toggleAmazonSESv2Config(false)
    },
    async save() {
      const validation = await this.$refs['send-email-account-form'].validate()

      if (!validation) return

      const payload = {
        sendEmailAccountId: this.selectedSendEmailAccountId,
        organizationId: this.organization.id
      }

      this.saveLoading = true
      await this.saveSESv2Account(payload)
      this.saveLoading = false

      this.toggleAmazonSESv2Config(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}
.text_color {
  color: #344054 !important;
}
</style>
